import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface ItemContentProps extends ComponentProps<'span'> {
  className?: string
}

/** The elastic middle: the title and the description, which take whatever width the controls leave. */
function ItemContent({ className, children, ...props }: ItemContentProps) {
  return (
    <span data-slot="item-content" className={twMerge('flex min-w-0 flex-1 flex-col gap-0.5', className)} {...props}>
      {children}
    </span>
  )
}

export { ItemContent }
export type { ItemContentProps }
